import {
  format,
  subDays,
  subWeeks,
  subMonths,
  subQuarters,
  subYears,
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  startOfQuarter,
  endOfQuarter,
  startOfYear,
  endOfYear,
} from 'date-fns';

const now = new Date();
const yesterday = subDays(now, 1);
const lastWeek = subWeeks(now, 1);
const lastMonth = subMonths(now, 1);
const lastYear = subYears(now, 1);
const lastQuarter = subQuarters(now, 1);
const firstDateOfWeek = startOfWeek(now);
const lastDateOfWeek = endOfWeek(now);
const firstDateOfLastWeek = startOfWeek(lastWeek);
const lastDateOfLastWeek = endOfWeek(lastWeek);
const firstDateOfLastMonth = startOfMonth(lastMonth);
const lastDateOfLastMonth = endOfMonth(lastMonth);
const firstDateOfQuarter = startOfQuarter(now);
const lastDateOfQuarter = endOfQuarter(now);
const firstDateOfLastQuarter = startOfQuarter(lastQuarter);
const lastDateOfLastQuarter = endOfQuarter(lastQuarter);
const firstDateOfYear = startOfYear(now);
const lastDateOfYear = endOfYear(now);
const firstDateOfLastYear = startOfYear(lastYear);
const lastDateOfLastYear = endOfYear(lastYear);

export const DATE_RANGES = [
  { value: 'all', presentation: 'All data' },
  { value: 'today', presentation: 'Today' },
  { value: 'yesterday', presentation: 'Yesterday' },
  { value: 'thisWeek', presentation: 'This week' },
  { value: 'lastWeek', presentation: 'Last week' },
  { value: 'lastMonth', presentation: 'Last month' },
  { value: 'thisQuarter', presentation: 'This quarter' },
  { value: 'lastQuarter', presentation: 'Last quarter' },
  { value: 'thisYear', presentation: 'This year' },
  { value: 'lastYear', presentation: 'Last Year' },
  { value: 'custom', presentation: 'Custom date range' },
];

export const formatTooltipDateRange = (rangeType, sDate = new Date(), eDate = new Date()) => {
  /* prettier-ignore */
  const MAPPED_FORMATTED_DATES = {
    [DATE_RANGES[0]['value']]: [ '', '' ],
    [DATE_RANGES[1]['value']] : [ 
      format(now, 'yyyy-MM-dd'),
      format(now, 'yyyy-MM-dd')
    ],
    [DATE_RANGES[2]['value']]: [
      format(yesterday, 'yyyy-MM-dd'),
      format(yesterday, 'yyyy-MM-dd')
    ],
    [DATE_RANGES[3]['value']]: [
      format(firstDateOfWeek, 'yyyy-MM-dd'),
      format(lastDateOfWeek, 'yyyy-MM-dd')
    ],
    [DATE_RANGES[4]['value']]: [
      format(firstDateOfLastWeek, 'yyyy-MM-dd'),
      format(lastDateOfLastWeek, 'yyyy-MM-dd')
    ],
    [DATE_RANGES[5]['value']]: [
      format(firstDateOfLastMonth, 'yyyy-MM-dd'),
      format(lastDateOfLastMonth, 'yyyy-MM-dd')
    ],
    [DATE_RANGES[6]['value']]: [
      format(firstDateOfQuarter, 'yyyy-MM-dd'),
      format(lastDateOfQuarter, 'yyyy-MM-dd')
    ],
    [DATE_RANGES[7]['value']]: [
      format(firstDateOfLastQuarter, 'yyyy-MM-dd'),
      format(lastDateOfLastQuarter, 'yyyy-MM-dd')
    ],
    [DATE_RANGES[8]['value']]: [
      format(firstDateOfYear, 'yyyy-MM-dd'),
      format(lastDateOfYear, 'yyyy-MM-dd')
    ],
    [DATE_RANGES[9]['value']]: [
      format(firstDateOfLastYear, 'yyyy-MM-dd'),
      format(lastDateOfLastYear, 'yyyy-MM-dd')
    ],
    [DATE_RANGES[10]['value']]: [
      format(sDate, 'yyyy-MM-dd'),
      format(eDate, 'yyyy-MM-dd')
    ]
  };

  return MAPPED_FORMATTED_DATES[rangeType];
};
